import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NotificationType } from 'src/app/models/notification.message';
import { NotificationService } from 'src/app/services/notification.service';
import { TokenService } from 'src/app/services/token.service';
import { UserService } from 'src/app/services/user.service';

@Component({
  selector: 'app-top-bar',
  templateUrl: './top-bar.component.html',
  styleUrls: ['./top-bar.component.css']
})
export class TopBarComponent implements OnInit {
  currentUser: any;
  constructor(private userService: UserService,private tokenService: TokenService, private router: Router,  private notification: NotificationService) { }

  ngOnInit(): void {
  }
  logout(){

    window.localStorage.clear();
    this.router.navigate(['signin']);

  }

  profile(){
    this.router.navigate(['profile']);
    this.currentUser = this.tokenService.getInfo();

  }
  changePassword(){
    //;
    this.router.navigate(['changepassword']);
  }

  
}
